import React from "react";

export default function WomensDayFrame1({ frameTextToggle, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2000 2000"
      width="300"
      height="300"
      fill="none"
    >
      <g transform={frameTextToggle}>
        <defs>
          <style>
            {
              ".clsw1-1{fill:#fbad5a}.clsw1-2{fill:#6d3649}.clsw1-3{fill:#fd5940}"
            }
          </style>
        </defs>
        <path
          className="clsw1-3"
          d="M1011.42 1308.81c-80.35 0-158.32-15.75-231.77-46.81-70.9-29.99-134.57-72.91-189.23-127.57s-97.58-118.32-127.57-189.23c-31.06-73.44-46.81-151.42-46.81-231.76s15.75-158.32 46.81-231.76c29.99-70.9 72.91-134.57 127.57-189.23s118.32-97.58 189.23-127.57c73.44-31.06 151.42-46.81 231.77-46.81s158.32 15.75 231.76 46.81c70.9 29.99 134.57 72.91 189.23 127.57s97.58 118.32 127.57 189.23c31.06 73.44 46.81 151.42 46.81 231.76s-15.75 158.33-46.81 231.76c-29.99 70.9-72.91 134.57-127.57 189.23s-118.32 97.58-189.23 127.57c-73.44 31.06-151.42 46.81-231.76 46.81Zm0-1067.75c-260.47 0-472.37 211.91-472.37 472.37s211.91 472.37 472.37 472.37 472.37-211.91 472.37-472.37-211.91-472.37-472.37-472.37Z"
        />
        <path
          className="clsw1-3"
          d="M1026.73 1922.44c-33.97 0-61.5-27.53-61.5-61.5v-567.67c0-33.97 27.53-61.5 61.5-61.5s61.5 27.53 61.5 61.5v567.67c0 33.97-27.53 61.5-61.5 61.5Z"
        />
        <path
          className="clsw1-3"
          d="M1247.32 1688.72H806.13c-33.97 0-61.5-27.53-61.5-61.5s27.53-61.5 61.5-61.5h441.19c33.97 0 61.5 27.53 61.5 61.5s-27.53 61.5-61.5 61.5Z"
        />
        <path
          className="clsw1-1"
          d="M1425.79 1100.35c5.05 9.73-.52 19.85-7.98 33.42-3.46 6.3-6.61 9.77-10.97 10.83-3.66.9-6.84-.23-7.93-.63-8.26-3.05-11.64-12.53-13.91-19.2-3.78-11.1-7.33-21.53-1.39-29.38 6.6-8.71 19.82-7.53 21.87-7.31 1.5.16 14.88 1.79 20.31 12.26Z"
        />
        <path
          className="clsw1-1"
          d="M1349.91 1127.26c9.29-5.8 19.83-1.06 33.95 5.3 6.56 2.95 10.26 5.82 11.67 10.08 1.19 3.58.32 6.83 0 7.96-2.38 8.48-11.57 12.59-18.04 15.38-10.76 4.65-20.88 9.01-29.18 3.71-9.21-5.89-9.07-19.16-9.02-21.22.04-1.5.61-14.97 10.61-21.22Z"
        />
        <path
          className="clsw1-1"
          d="M1355.58 1185.59c1.38-10.87 11.73-16.03 25.58-22.94 6.44-3.21 10.99-4.27 15.19-2.66 3.52 1.35 5.49 4.08 6.16 5.03 5.06 7.21 2.44 16.93.51 23.7-3.21 11.28-6.23 21.88-15.58 24.95-10.38 3.41-20.58-5.09-22.14-6.44-1.14-.98-11.21-9.94-9.72-21.64Z"
        />
        <path
          className="clsw1-1"
          d="M1421.7 1213.75c-10.54-3-14.09-14-18.85-28.73-2.21-6.84-2.57-11.51-.36-15.42 1.86-3.28 4.85-4.82 5.9-5.34 7.88-3.92 17.1.13 23.51 3.05 10.67 4.86 20.7 9.43 22.33 19.14 1.81 10.77-8.12 19.59-9.68 20.93-1.14.98-11.51 9.6-22.85 6.37Z"
        />
        <path
          className="clsw1-1"
          d="M1460.1 1159.14c-7.17 8.29-18.64 6.86-34 4.95-7.14-.89-11.52-2.53-14.12-6.19-2.19-3.07-2.32-6.44-2.35-7.6-.22-8.8 7.34-15.45 12.69-20.02 8.91-7.62 17.29-14.78 26.78-12.16 10.53 2.91 14.33 15.63 14.88 17.61.4 1.45 3.84 14.49-3.87 23.4Z"
        />
        <ellipse
          className="clsw1-3"
          cx={1404.08}
          cy={1153.31}
          rx={16.49}
          ry={20.57}
        />
        <path
          className="clsw1-1"
          d="M1261.99 169.71c6.37 12.27-.66 25.05-10.07 42.17-4.37 7.95-8.34 12.32-13.84 13.67-4.62 1.13-8.63-.29-10.01-.8-10.42-3.84-14.68-15.81-17.55-24.22-4.77-14-9.25-27.17-1.75-37.07 8.32-10.99 25.01-9.5 27.59-9.22 1.89.2 18.77 2.26 25.63 15.47Z"
        />
        <path
          className="clsw1-1"
          d="M1166.25 203.66c11.73-7.32 25.03-1.33 42.84 6.69 8.27 3.73 12.95 7.34 14.73 12.72 1.5 4.52.4 8.62 0 10.04-3.01 10.69-14.6 15.89-22.76 19.41-13.58 5.86-26.35 11.37-36.81 4.69-11.62-7.43-11.45-24.18-11.38-26.77.05-1.9.77-18.89 13.39-26.77Z"
        />
        <path
          className="clsw1-1"
          d="M1173.41 277.27c1.75-13.72 14.8-20.23 32.28-28.95 8.12-4.05 13.87-5.38 19.16-3.36 4.45 1.7 6.93 5.15 7.78 6.35 6.38 9.09 3.07 21.36.64 29.91-4.05 14.23-7.86 27.61-19.66 31.48-13.1 4.3-25.97-6.43-27.94-8.12-1.44-1.24-14.15-12.55-12.27-27.3Z"
        />
        <path
          className="clsw1-1"
          d="M1256.84 312.79c-13.3-3.78-17.78-17.66-23.79-36.25-2.79-8.64-3.25-14.52-.45-19.45 2.35-4.14 6.13-6.08 7.44-6.74 9.95-4.95 21.58.16 29.66 3.84 13.46 6.14 26.12 11.9 28.18 24.15 2.29 13.6-10.24 24.72-12.21 26.4-1.44 1.24-14.52 12.11-28.83 8.04Z"
        />
        <path
          className="clsw1-1"
          d="M1305.29 243.88c-9.05 10.46-23.52 8.66-42.91 6.25-9.01-1.12-14.54-3.19-17.82-7.81-2.76-3.88-2.93-8.12-2.96-9.59-.28-11.11 9.26-19.49 16.02-25.26 11.25-9.61 21.82-18.64 33.79-15.34 13.29 3.67 18.08 19.73 18.77 22.22.51 1.83 4.84 18.28-4.89 29.53Z"
        />
        <ellipse
          className="clsw1-3"
          cx={1234.61}
          cy={236.52}
          rx={20.81}
          ry={25.96}
        />
        <path
          className="clsw1-1"
          d="M885.87 237.64c2.87 5.53-.3 11.29-4.54 19-1.97 3.58-3.76 5.55-6.24 6.16-2.08.51-3.89-.13-4.51-.36-4.7-1.73-6.62-7.13-7.91-10.92-2.15-6.31-4.17-12.24-.79-16.7 3.75-4.95 11.27-4.28 12.43-4.16.85.09 8.46 1.02 11.55 6.97Z"
        />
        <path
          className="clsw1-1"
          d="M842.73 252.93c5.29-3.3 11.28-.6 19.3 3.02 3.73 1.68 5.83 3.31 6.64 5.73.67 2.04.18 3.89 0 4.52-1.35 4.82-6.58 7.16-10.25 8.75-6.12 2.64-11.87 5.13-16.59 2.11-5.23-3.35-5.16-10.9-5.13-12.06.02-.86.35-8.51 6.03-12.06Z"
        />
        <path
          className="clsw1-1"
          d="M845.95 286.1c.79-6.18 6.67-9.11 14.55-13.04 3.66-1.83 6.25-2.43 8.64-1.51 2 .77 3.12 2.32 3.5 2.86 2.88 4.1 1.38 9.62.29 13.48-1.83 6.41-3.54 12.44-8.86 14.18-5.9 1.94-11.7-2.9-12.59-3.66-.65-.56-6.38-5.65-5.53-12.3Z"
        />
        <path
          className="clsw1-1"
          d="M883.55 302.11c-5.99-1.7-8.01-7.96-10.72-16.33-1.26-3.89-1.46-6.54-.2-8.77 1.06-1.87 2.76-2.74 3.35-3.04 4.48-2.23 9.72.07 13.37 1.73 6.07 2.76 11.77 5.36 12.7 10.88 1.03 6.13-4.62 11.14-5.5 11.9-.65.56-6.54 5.46-12.99 3.62Z"
        />
        <path
          className="clsw1-1"
          d="M905.38 271.06c-4.08 4.71-10.6 3.9-19.33 2.81-4.06-.5-6.55-1.44-8.03-3.52-1.24-1.75-1.32-3.66-1.34-4.32-.13-5 4.17-8.78 7.22-11.38 5.07-4.33 9.83-8.4 15.23-6.91 5.99 1.65 8.15 8.89 8.46 10.01.23.82 2.18 8.24-2.2 13.31Z"
        />
        <ellipse
          className="clsw1-3"
          cx={873.53}
          cy={267.74}
          rx={9.38}
          ry={11.7}
        />
        <path
          className="clsw1-1"
          d="M1619.81 484.24c-7.98 6.13-18.04 2.72-31.51-1.84-6.26-2.12-9.9-4.41-11.56-8.18-1.4-3.17-.89-6.22-.71-7.28 1.43-7.96 9.46-12.54 15.13-15.66 9.43-5.2 18.3-10.09 26.35-5.98 8.94 4.57 9.99 16.72 10.13 18.6.1 1.38.77 13.75-7.82 20.34Z"
        />
        <path
          className="clsw1-1"
          d="M1583.28 419.94c6.74 7.47 4.14 17.77.66 31.56-1.62 6.41-3.61 10.21-7.24 12.18-3.05 1.65-6.13 1.38-7.2 1.28-8.05-.79-13.25-8.44-16.81-13.84-5.93-8.99-11.51-17.44-8.05-25.79 3.84-9.27 15.87-11.29 17.74-11.57 1.37-.2 13.64-1.86 20.9 6.18Z"
        />
        <path
          className="clsw1-1"
          d="M1531.43 434.45c10.05-.5 16.38 8.03 24.86 19.45 3.94 5.3 5.63 9.26 4.85 13.31-.65 3.4-2.81 5.62-3.56 6.38-5.7 5.73-14.92 4.92-21.35 4.27-10.71-1.09-20.79-2.12-25.07-10.08-4.75-8.84 1.3-19.44 2.26-21.06.71-1.19 7.19-11.74 18.01-12.27Z"
        />
        <path
          className="clsw1-1"
          d="M1516.59 498.78c1.01-10.02 10.39-15 22.95-21.67 5.83-3.1 10-4.18 13.88-2.8 3.27 1.15 5.14 3.62 5.78 4.48 4.81 6.5 2.64 15.49 1.02 21.75-2.68 10.43-5.2 20.24-13.72 23.28-9.45 3.37-19.02-4.19-20.48-5.39-1.07-.88-10.53-8.87-9.44-19.64Z"
        />
        <path
          className="clsw1-1"
          d="M1572.16 524.72c-8.65-5.15-9.2-15.75-9.95-29.96-.34-6.6.44-10.83 3.32-13.77 2.43-2.47 5.45-3.13 6.5-3.35 7.92-1.62 15.15 4.15 20.15 8.26 8.32 6.84 16.14 13.27 15.3 22.27-.94 9.99-11.84 15.47-13.54 16.29-1.25.6-12.49 5.8-21.79.26Z"
        />
        <ellipse
          className="clsw1-3"
          cx={1568.43}
          cy={473.12}
          rx={18.9}
          ry={15.15}
          transform="rotate(-10.08 1568.63 473.154)"
        />
        <path
          className="clsw1-1"
          d="M1476.59 915.42c-4.7 3.61-10.62 1.6-18.55-1.08-3.68-1.25-5.83-2.6-6.81-4.82-.82-1.87-.53-3.66-.42-4.28.84-4.69 5.57-7.38 8.9-9.22 5.55-3.06 10.77-5.94 15.51-3.52 5.26 2.69 5.88 9.84 5.96 10.95.06.81.45 8.09-4.6 11.97Z"
        />
        <path
          className="clsw1-1"
          d="M1455.09 877.57c3.97 4.4 2.44 10.46.39 18.58-.95 3.77-2.13 6.01-4.26 7.17-1.79.97-3.61.81-4.24.75-4.74-.47-7.8-4.97-9.9-8.15-3.49-5.29-6.78-10.27-4.74-15.18 2.26-5.46 9.34-6.64 10.44-6.81.8-.12 8.03-1.09 12.3 3.64Z"
        />
        <path
          className="clsw1-1"
          d="M1424.57 886.11c5.92-.29 9.64 4.73 14.63 11.45 2.32 3.12 3.31 5.45 2.86 7.83-.38 2-1.65 3.31-2.1 3.76-3.36 3.37-8.78 2.9-12.57 2.51-6.31-.64-12.24-1.25-14.76-5.93-2.8-5.2.76-11.44 1.33-12.4.42-.7 4.23-6.91 10.6-7.22Z"
        />
        <path
          className="clsw1-1"
          d="M1415.83 923.97c.6-5.9 6.12-8.83 13.51-12.76 3.43-1.82 5.88-2.46 8.17-1.65 1.92.68 3.03 2.13 3.4 2.64 2.83 3.83 1.55 9.12.6 12.8-1.58 6.14-3.06 11.91-8.07 13.7-5.56 1.99-11.2-2.47-12.06-3.17-.63-.52-6.2-5.22-5.56-11.56Z"
        />
        <path
          className="clsw1-1"
          d="M1448.55 939.25c-5.09-3.03-5.42-9.27-5.85-17.63-.2-3.88.26-6.37 1.96-8.11 1.43-1.46 3.21-1.84 3.83-1.97 4.66-.95 8.92 2.45 11.86 4.86 4.9 4.02 9.5 7.81 9.01 13.11-.55 5.88-6.97 9.11-7.97 9.59-.73.35-7.35 3.41-12.83.15Z"
        />
        <ellipse
          className="clsw1-3"
          cx={1446.35}
          cy={908.87}
          rx={11.12}
          ry={8.92}
          transform="rotate(-10.08 1446.55 908.957)"
        />
        <path
          className="clsw1-1"
          d="M658.44 484.78c-6.71 5.15-15.17 2.29-26.49-1.55-5.26-1.78-8.32-3.71-9.72-6.88-1.18-2.66-.75-5.23-.59-6.12 1.2-6.69 7.96-10.54 12.72-13.17 7.93-4.37 15.38-8.48 22.15-5.03 7.52 3.84 8.4 14.06 8.51 15.64.08 1.16.65 11.56-6.57 17.1Z"
        />
        <path
          className="clsw1-1"
          d="M627.73 430.72c5.67 6.28 3.48 14.94.56 26.53-1.36 5.39-3.04 8.59-6.09 10.24-2.56 1.39-5.15 1.16-6.05 1.08-6.77-.67-11.14-7.1-14.14-11.63-4.99-7.56-9.68-14.66-6.77-21.68 3.23-7.8 13.35-9.49 14.92-9.73 1.15-.17 11.47-1.56 17.57 5.2Z"
        />
        <path
          className="clsw1-1"
          d="M584.14 442.92c8.45-.42 13.77 6.75 20.9 16.35 3.31 4.46 4.73 7.78 4.08 11.19-.55 2.86-2.36 4.73-2.99 5.37-4.8 4.82-12.54 4.14-17.95 3.59-9.01-.92-17.48-1.78-21.08-8.47-3.99-7.43 1.09-16.34 1.9-17.7.59-1 6.04-9.87 15.14-10.32Z"
        />
        <path
          className="clsw1-1"
          d="M571.66 497.01c.85-8.42 8.74-12.61 19.3-18.22 4.91-2.61 8.4-3.51 11.67-2.36 2.75.97 4.32 3.04 4.86 3.76 4.05 5.46 2.22 13.02.86 18.29-2.25 8.77-4.38 17.01-11.53 19.57-7.95 2.84-15.99-3.52-17.22-4.53-.9-.74-8.85-7.45-7.94-16.51Z"
        />
        <path
          className="clsw1-1"
          d="M618.38 518.82c-7.27-4.33-7.74-13.25-8.36-25.19-.29-5.55.37-9.1 2.79-11.58 2.04-2.08 4.58-2.63 5.46-2.81 6.66-1.36 12.74 3.49 16.94 6.94 7 5.75 13.57 11.15 12.87 18.72-.79 8.4-9.95 13.01-11.38 13.69-1.05.5-10.5 4.88-18.32.22Z"
        />
        <ellipse
          className="clsw1-3"
          cx={615.24}
          cy={475.44}
          rx={15.89}
          ry={12.74}
          transform="rotate(-10.08 615.352 475.47)"
        />
        <path
          className="clsw1-1"
          d="M454.8 811.51c-5.57 4.27-12.58 1.9-21.97-1.28-4.36-1.48-6.9-3.07-8.06-5.7-.98-2.21-.62-4.34-.49-5.07 1-5.55 6.6-8.74 10.55-10.92 6.58-3.63 12.76-7.04 18.37-4.17 6.23 3.18 6.97 11.66 7.06 12.97.07.96.54 9.58-5.45 14.18Z"
        />
        <path
          className="clsw1-1"
          d="M429.32 766.67c4.7 5.21 2.89 12.39.46 22.01-1.13 4.47-2.52 7.12-5.05 8.49-2.13 1.15-4.27.97-5.02.89-5.61-.55-9.24-5.89-11.72-9.65-4.14-6.27-8.03-12.16-5.61-17.98 2.68-6.47 11.07-7.87 12.37-8.07.95-.14 9.51-1.3 14.57 4.31Z"
        />
        <path
          className="clsw1-1"
          d="M393.17 776.79c7.01-.35 11.42 5.6 17.34 13.56 2.75 3.7 3.92 6.46 3.38 9.28-.45 2.37-1.96 3.92-2.48 4.45-3.98 4-10.4 3.43-14.89 2.98-7.47-.76-14.5-1.47-17.48-7.03-3.31-6.17.9-13.55 1.58-14.68.49-.83 5.01-8.19 12.56-8.56Z"
        />
        <path
          className="clsw1-1"
          d="M382.83 821.64c.71-6.98 7.25-10.46 16-15.11 4.07-2.16 6.97-2.91 9.68-1.96 2.28.8 3.58 2.52 4.03 3.12 3.36 4.53 1.84 10.8.71 15.17-1.87 7.27-3.63 14.11-9.56 16.23-6.59 2.35-13.26-2.92-14.28-3.76-.75-.61-7.34-6.18-6.58-13.7Z"
        />
        <path
          className="clsw1-1"
          d="M421.57 839.74c-6.03-3.59-6.42-10.99-6.93-20.89-.24-4.6.3-7.55 2.32-9.6 1.69-1.73 3.8-2.18 4.53-2.33 5.53-1.13 10.56 2.9 14.05 5.76 5.8 4.77 11.26 9.25 10.67 15.53-.65 6.97-8.25 10.79-9.44 11.36-.87.42-8.71 4.04-15.19.18Z"
        />
        <ellipse
          className="clsw1-3"
          cx={418.97}
          cy={803.76}
          rx={13.18}
          ry={10.57}
          transform="rotate(-10.08 419.044 803.827)"
        />
        <path
          className="clsw1-1"
          d="M682.21 1024.92c-4.07 3.12-9.19 1.39-16.06-.94-3.19-1.08-5.04-2.25-5.89-4.17-.71-1.61-.46-3.17-.36-3.71.73-4.06 4.82-6.39 7.71-7.98 4.8-2.65 9.32-5.14 13.42-3.05 4.55 2.33 5.09 8.52 5.16 9.48.05.7.39 7-3.98 10.36Z"
        />
        <path
          className="clsw1-1"
          d="M663.6 992.16c3.44 3.81 2.11 9.05.34 16.08-.82 3.26-1.84 5.2-3.69 6.2-1.55.84-3.12.71-3.67.65-4.1-.4-6.75-4.3-8.57-7.05-3.02-4.58-5.86-8.89-4.1-13.14 1.96-4.72 8.09-5.75 9.04-5.89.7-.1 6.95-.95 10.65 3.15Z"
        />
        <path
          className="clsw1-1"
          d="M637.18 999.56c5.12-.25 8.35 4.09 12.67 9.91 2.01 2.7 2.87 4.72 2.47 6.78-.33 1.73-1.43 2.87-1.81 3.25-2.91 2.92-7.6 2.51-10.88 2.18-5.46-.56-10.59-1.08-12.77-5.13-2.42-4.5.66-9.9 1.15-10.73.36-.61 3.66-5.98 9.17-6.25Z"
        />
        <path
          className="clsw1-1"
          d="M629.62 1032.33c.52-5.1 5.29-7.64 11.69-11.04 2.97-1.58 5.09-2.13 7.07-1.43 1.66.59 2.62 1.84 2.94 2.28 2.45 3.31 1.34 7.89.52 11.08-1.37 5.31-2.65 10.31-6.99 11.86-4.82 1.72-9.69-2.14-10.44-2.75-.54-.45-5.37-4.52-4.81-10.01Z"
        />
        <path
          className="clsw1-1"
          d="M657.93 1045.55c-4.41-2.62-4.69-8.03-5.07-15.26-.18-3.36.22-5.52 1.69-7.02 1.24-1.26 2.78-1.6 3.31-1.7 4.04-.82 7.72 2.12 10.27 4.21 4.24 3.48 8.23 6.76 7.8 11.34-.48 5.09-6.03 7.88-6.9 8.3-.63.31-6.36 2.96-11.1.13Z"
        />
        <ellipse
          className="clsw1-3"
          cx={656.03}
          cy={1019.26}
          rx={9.63}
          ry={7.72}
          transform="rotate(-10.08 656.113 1019.395)"
        />
        <path
          className="clsw1-1"
          d="M995.42 1308.19c-4.7 3.61-10.62 1.6-18.55-1.08-3.68-1.25-5.83-2.6-6.81-4.82-.82-1.87-.53-3.66-.42-4.28.84-4.69 5.57-7.38 8.9-9.22 5.55-3.06 10.77-5.94 15.51-3.52 5.26 2.69 5.88 9.84 5.96 10.95.06.81.45 8.09-4.6 11.97Z"
        />
        <path
          className="clsw1-1"
          d="M973.91 1270.35c3.97 4.4 2.44 10.46.39 18.58-.95 3.77-2.13 6.01-4.26 7.17-1.79.97-3.61.81-4.24.75-4.74-.47-7.8-4.97-9.9-8.15-3.49-5.29-6.78-10.27-4.74-15.18 2.26-5.46 9.34-6.64 10.44-6.81.8-.12 8.03-1.09 12.3 3.64Z"
        />
        <path
          className="clsw1-1"
          d="M943.39 1278.89c5.92-.29 9.64 4.73 14.63 11.45 2.32 3.12 3.31 5.45 2.86 7.83-.38 2-1.65 3.31-2.1 3.76-3.36 3.37-8.78 2.9-12.57 2.51-6.31-.64-12.24-1.25-14.76-5.93-2.8-5.2.76-11.44 1.33-12.4.42-.7 4.23-6.91 10.6-7.22Z"
        />
        <path
          className="clsw1-1"
          d="M934.66 1316.75c.6-5.9 6.12-8.83 13.51-12.76 3.43-1.82 5.88-2.46 8.17-1.65 1.92.68 3.03 2.13 3.4 2.64 2.83 3.83 1.55 9.12.6 12.8-1.58 6.14-3.06 11.91-8.07 13.7-5.56 1.99-11.2-2.47-12.06-3.17-.63-.52-6.2-5.22-5.56-11.56Z"
        />
        <path
          className="clsw1-1"
          d="M967.37 1332.03c-5.09-3.03-5.42-9.27-5.85-17.63-.2-3.88.26-6.37 1.96-8.11 1.43-1.46 3.21-1.84 3.83-1.97 4.66-.95 8.92 2.45 11.86 4.86 4.9 4.02 9.5 7.81 9.01 13.11-.55 5.88-6.97 9.11-7.97 9.59-.73.35-7.35 3.41-12.83.15Z"
        />
        <ellipse
          className="clsw1-3"
          cx={965.17}
          cy={1301.65}
          rx={11.12}
          ry={8.92}
          transform="rotate(-10.08 965.28 1301.77)"
        />
        <path
          className="clsw1-1"
          d="M991.18 1825c-4.7 3.61-10.62 1.6-18.55-1.08-3.68-1.25-5.83-2.6-6.81-4.82-.82-1.87-.53-3.66-.42-4.28.84-4.69 5.57-7.38 8.9-9.22 5.55-3.06 10.77-5.94 15.51-3.52 5.26 2.69 5.88 9.84 5.96 10.95.06.81.45 8.09-4.6 11.97Z"
        />
        <path
          className="clsw1-1"
          d="M969.68 1787.15c3.97 4.4 2.44 10.46.39 18.58-.95 3.77-2.13 6.01-4.26 7.17-1.79.97-3.61.81-4.24.75-4.74-.47-7.8-4.97-9.9-8.15-3.49-5.29-6.78-10.27-4.74-15.18 2.26-5.46 9.34-6.64 10.44-6.81.8-.12 8.03-1.09 12.3 3.64Z"
        />
        <path
          className="clsw1-1"
          d="M939.16 1795.69c5.92-.29 9.64 4.73 14.63 11.45 2.32 3.12 3.31 5.45 2.86 7.83-.38 2-1.65 3.31-2.1 3.76-3.36 3.37-8.78 2.9-12.57 2.51-6.31-.64-12.24-1.25-14.76-5.93-2.8-5.2.76-11.44 1.33-12.4.42-.7 4.23-6.91 10.6-7.22Z"
        />
        <path
          className="clsw1-1"
          d="M930.42 1833.56c.6-5.9 6.12-8.83 13.51-12.76 3.43-1.82 5.88-2.46 8.17-1.65 1.92.68 3.03 2.13 3.4 2.64 2.83 3.83 1.55 9.12.6 12.8-1.58 6.14-3.06 11.91-8.07 13.7-5.56 1.99-11.2-2.47-12.06-3.17-.63-.52-6.2-5.22-5.56-11.56Z"
        />
        <path
          className="clsw1-1"
          d="M963.14 1848.83c-5.09-3.03-5.42-9.27-5.85-17.63-.2-3.88.26-6.37 1.96-8.11 1.43-1.46 3.21-1.84 3.83-1.97 4.66-.95 8.92 2.45 11.86 4.86 4.9 4.02 9.5 7.81 9.01 13.11-.55 5.88-6.97 9.11-7.97 9.59-.73.35-7.35 3.41-12.83.15Z"
        />
        <ellipse
          className="clsw1-3"
          cx={960.94}
          cy={1818.46}
          rx={11.12}
          ry={8.92}
          transform="rotate(-10.08 961.062 1818.644)"
        />
        <path
          className="clsw1-1"
          d="M895.39 1689.78c-3.9 2.99-8.81 1.33-15.38-.9-3.05-1.04-4.83-2.15-5.65-3.99-.68-1.55-.44-3.04-.34-3.55.7-3.89 4.62-6.12 7.39-7.65 4.6-2.54 8.93-4.93 12.86-2.92 4.36 2.23 4.88 8.16 4.94 9.08.05.67.38 6.71-3.82 9.93Z"
        />
        <path
          className="clsw1-1"
          d="M877.56 1658.39c3.29 3.65 2.02 8.67.32 15.41-.79 3.13-1.76 4.99-3.53 5.94-1.49.8-2.99.68-3.51.62-3.93-.39-6.47-4.12-8.21-6.76-2.9-4.39-5.62-8.51-3.93-12.59 1.88-4.53 7.75-5.51 8.66-5.65.67-.1 6.66-.91 10.2 3.02Z"
        />
        <path
          className="clsw1-1"
          d="M852.24 1665.47c4.91-.24 8 3.92 12.14 9.49 1.92 2.59 2.75 4.52 2.37 6.5-.32 1.66-1.37 2.75-1.74 3.12-2.78 2.8-7.28 2.4-10.42 2.08-5.23-.53-10.15-1.03-12.24-4.92-2.32-4.32.63-9.49 1.1-10.28.34-.58 3.51-5.73 8.79-5.99Z"
        />
        <path
          className="clsw1-1"
          d="M845 1696.88c.5-4.89 5.07-7.32 11.2-10.58 2.85-1.51 4.88-2.04 6.78-1.37 1.6.56 2.51 1.77 2.82 2.19 2.35 3.17 1.29 7.56.5 10.62-1.31 5.09-2.54 9.88-6.7 11.36-4.62 1.65-9.29-2.05-10-2.63-.52-.43-5.14-4.33-4.61-9.59Z"
        />
        <path
          className="clsw1-1"
          d="M872.13 1709.54c-4.22-2.51-4.49-7.69-4.86-14.63-.17-3.22.21-5.28 1.62-6.72 1.18-1.21 2.66-1.53 3.17-1.63 3.87-.79 7.4 2.03 9.84 4.03 4.06 3.34 7.88 6.48 7.47 10.87-.46 4.88-5.78 7.55-6.61 7.95-.61.29-6.1 2.83-10.64.13Z"
        />
        <ellipse
          className="clsw1-3"
          cx={870.31}
          cy={1684.35}
          rx={9.22}
          ry={7.4}
          transform="rotate(-10.08 870.444 1684.555)"
        />
        <path
          className="clsw1-1"
          d="M1150.12 1578.71c-7.48 5.74-16.9 2.55-29.52-1.73-5.86-1.99-9.27-4.13-10.83-7.66-1.31-2.97-.84-5.83-.66-6.81 1.34-7.46 8.86-11.75 14.17-14.67 8.83-4.87 17.14-9.45 24.68-5.6 8.37 4.28 9.36 15.66 9.48 17.42.09 1.29.72 12.88-7.33 19.05Z"
        />
        <path
          className="clsw1-1"
          d="M1115.9 1518.48c6.32 7 3.88 16.64.62 29.56-1.52 6-3.38 9.57-6.78 11.4-2.86 1.54-5.74 1.3-6.74 1.2-7.54-.74-12.41-7.91-15.75-12.96-5.56-8.42-10.78-16.34-7.54-24.16 3.6-8.69 14.87-10.57 16.62-10.84 1.28-.19 12.78-1.74 19.57 5.79Z"
        />
        <path
          className="clsw1-1"
          d="M1067.33 1532.08c9.42-.47 15.35 7.52 23.29 18.22 3.69 4.97 5.27 8.67 4.54 12.47-.61 3.19-2.63 5.27-3.34 5.98-5.34 5.37-13.97 4.61-20 4-10.04-1.02-19.47-1.98-23.48-9.44-4.45-8.28 1.22-18.21 2.12-19.73.66-1.11 6.73-11 16.87-11.5Z"
        />
        <path
          className="clsw1-1"
          d="M1053.44 1592.33c.95-9.38 9.73-14.05 21.5-20.3 5.46-2.9 9.36-3.91 13.01-2.63 3.06 1.08 4.81 3.39 5.41 4.19 4.51 6.09 2.47 14.51.96 20.38-2.51 9.77-4.87 18.96-12.85 21.8-8.86 3.16-17.82-3.93-19.19-5.05-1-.82-9.86-8.3-8.84-18.4Z"
        />
        <path
          className="clsw1-1"
          d="M1105.49 1616.64c-8.1-4.82-8.62-14.76-9.32-28.06-.32-6.18.41-10.14 3.11-12.9 2.27-2.32 5.1-2.93 6.09-3.13 7.42-1.52 14.19 3.89 18.87 7.74 7.79 6.4 15.12 12.43 14.33 20.86-.88 9.36-11.09 14.49-12.68 15.26-1.17.56-11.69 5.43-20.41.24Z"
        />
        <ellipse
          className="clsw1-3"
          cx={1101.99}
          cy={1568.3}
          rx={17.7}
          ry={14.19}
          transform="rotate(-10.08 1102.136 1568.492)"
        />
        <path
          className="clsw1-1"
          d="M607.38 320.51c-4.7 3.61-10.62 1.6-18.55-1.08-3.68-1.25-5.83-2.6-6.81-4.82-.82-1.87-.53-3.66-.42-4.28.84-4.69 5.57-7.38 8.9-9.22 5.55-3.06 10.77-5.94 15.51-3.52 5.26 2.69 5.88 9.84 5.96 10.95.06.81.45 8.09-4.6 11.97Z"
        />
        <path
          className="clsw1-1"
          d="M585.88 282.67c3.97 4.4 2.44 10.46.39 18.58-.95 3.77-2.13 6.01-4.26 7.17-1.79.97-3.61.81-4.24.75-4.74-.47-7.8-4.97-9.9-8.15-3.49-5.29-6.78-10.27-4.74-15.18 2.26-5.46 9.34-6.64 10.44-6.81.8-.12 8.03-1.09 12.3 3.64Z"
        />
        <path
          className="clsw1-1"
          d="M555.36 291.21c5.92-.29 9.64 4.73 14.63 11.45 2.32 3.12 3.31 5.45 2.86 7.83-.38 2-1.65 3.31-2.1 3.76-3.36 3.37-8.78 2.9-12.57 2.51-6.31-.64-12.24-1.25-14.76-5.93-2.8-5.2.76-11.44 1.33-12.4.42-.7 4.23-6.91 10.6-7.22Z"
        />
        <path
          className="clsw1-1"
          d="M546.63 329.07c.6-5.9 6.12-8.83 13.51-12.76 3.43-1.82 5.88-2.46 8.17-1.65 1.92.68 3.03 2.13 3.4 2.64 2.83 3.83 1.55 9.12.6 12.8-1.58 6.14-3.06 11.91-8.07 13.7-5.56 1.99-11.2-2.47-12.06-3.17-.63-.52-6.2-5.22-5.56-11.56Z"
        />
        <path
          className="clsw1-1"
          d="M579.34 344.35c-5.09-3.03-5.42-9.27-5.85-17.63-.2-3.88.26-6.37 1.96-8.11 1.43-1.46 3.21-1.84 3.83-1.97 4.66-.95 8.92 2.45 11.86 4.86 4.9 4.02 9.5 7.81 9.01 13.11-.55 5.88-6.97 9.11-7.97 9.59-.73.35-7.35 3.41-12.83.15Z"
        />
        <ellipse
          className="clsw1-3"
          cx={577.14}
          cy={313.97}
          rx={11.12}
          ry={8.92}
          transform="rotate(-10.08 577.198 314.013)"
        />
        <path
          className="clsw1-1"
          d="M577.93 847.49c3.83 7.39-.39 15.08-6.06 25.38-2.63 4.79-5.02 7.42-8.33 8.23-2.78.68-5.19-.17-6.02-.48-6.27-2.31-8.84-9.52-10.56-14.58-2.87-8.43-5.57-16.35-1.06-22.31 5.01-6.62 15.06-5.72 16.61-5.55 1.14.12 11.3 1.36 15.43 9.31Z"
        />
        <path
          className="clsw1-1"
          d="M520.31 867.92c7.06-4.41 15.06-.8 25.78 4.03 4.98 2.24 7.79 4.42 8.86 7.65.9 2.72.24 5.19 0 6.04-1.81 6.44-8.79 9.56-13.7 11.68-8.17 3.53-15.86 6.85-22.16 2.82-6.99-4.47-6.89-14.55-6.85-16.11.03-1.14.46-11.37 8.06-16.11Z"
        />
        <path
          className="clsw1-1"
          d="M524.61 912.22c1.05-8.26 8.91-12.17 19.43-17.42 4.89-2.44 8.35-3.24 11.53-2.02 2.68 1.02 4.17 3.1 4.68 3.82 3.84 5.47 1.85 12.86.39 18-2.44 8.56-4.73 16.61-11.83 18.95-7.88 2.59-15.63-3.87-16.81-4.89-.87-.75-8.52-7.55-7.38-16.43Z"
        />
        <path
          className="clsw1-1"
          d="M574.83 933.61c-8.01-2.28-10.7-10.63-14.32-21.82-1.68-5.2-1.95-8.74-.27-11.71 1.41-2.49 3.69-3.66 4.48-4.06 5.99-2.98 12.99.1 17.85 2.31 8.1 3.69 15.72 7.16 16.96 14.53 1.38 8.18-6.17 14.88-7.35 15.89-.87.74-8.74 7.29-17.35 4.84Z"
        />
        <path
          className="clsw1-1"
          d="M603.99 892.13c-5.44 6.29-14.16 5.21-25.82 3.76-5.42-.67-8.75-1.92-10.73-4.7-1.66-2.33-1.76-4.89-1.78-5.77-.17-6.68 5.57-11.73 9.64-15.2 6.77-5.78 13.13-11.22 20.34-9.23 8 2.21 10.88 11.87 11.3 13.38.31 1.1 2.91 11-2.94 17.77Z"
        />
        <ellipse
          className="clsw1-3"
          cx={561.45}
          cy={887.7}
          rx={12.53}
          ry={15.62}
        />
        <path
          className="clsw1-2"
          d="M1563.42 731.01c-2.86 2.5-6.74 1.46-11.93.06-2.41-.65-3.84-1.42-4.56-2.81-.6-1.16-.49-2.32-.44-2.73.35-3.04 3.27-4.96 5.33-6.27 3.43-2.19 6.66-4.25 9.79-2.89 3.48 1.51 4.17 6.06 4.27 6.77.07.52.62 5.16-2.46 7.86Z"
        />
        <path
          className="clsw1-2"
          d="M1548.1 707.64c2.72 2.66 1.99 6.6 1.01 11.88-.46 2.45-1.12 3.94-2.44 4.77-1.11.69-2.28.67-2.68.66-3.05-.1-5.2-2.86-6.67-4.81-2.45-3.25-4.76-6.3-3.66-9.53 1.23-3.59 5.71-4.64 6.41-4.79.51-.11 5.1-1.03 8.03 1.83Z"
        />
        <path
          className="clsw1-2"
          d="M1528.9 714.36c3.78-.43 6.37 2.63 9.84 6.74 1.61 1.91 2.34 3.36 2.15 4.9-.16 1.3-.92 2.19-1.19 2.49-2.01 2.3-5.51 2.22-7.95 2.12-4.07-.15-7.89-.3-9.7-3.2-2-3.22.02-7.36.35-8 .24-.47 2.43-4.6 6.49-5.06Z"
        />
        <path
          className="clsw1-2"
          d="M1524.85 738.97c.14-3.8 3.56-5.91 8.13-8.72 2.13-1.31 3.67-1.82 5.17-1.39 1.26.36 2.03 1.24 2.29 1.55 1.97 2.33 1.37 5.78.91 8.18-.76 4-1.47 7.76-4.61 9.11-3.48 1.5-7.27-1.12-7.85-1.54-.42-.3-4.18-3.09-4.03-7.18Z"
        />
        <path
          className="clsw1-2"
          d="M1546.43 747.42c-3.39-1.73-3.85-5.72-4.47-11.06-.29-2.48-.1-4.09.92-5.27.86-.99 1.98-1.31 2.37-1.42 2.95-.8 5.81 1.2 7.8 2.63 3.3 2.38 6.41 4.61 6.31 8.03-.11 3.79-4.09 6.12-4.71 6.47-.46.26-4.57 2.49-8.21.62Z"
        />
        <ellipse
          className="clsw1-1"
          cx={1543.78}
          cy={728.05}
          rx={7.14}
          ry={5.73}
          transform="rotate(-13.73 1544.364 728.26)"
        />
        <path
          className="clsw1-2"
          d="M1501.07 641.12c-2.86 2.5-6.74 1.46-11.93.06-2.41-.65-3.84-1.42-4.56-2.81-.6-1.16-.49-2.32-.44-2.73.35-3.04 3.27-4.96 5.33-6.27 3.43-2.19 6.66-4.25 9.79-2.89 3.48 1.51 4.17 6.06 4.27 6.77.07.52.62 5.16-2.46 7.86Z"
        />
        <path
          className="clsw1-2"
          d="M1485.75 617.75c2.72 2.66 1.99 6.6 1.01 11.88-.46 2.45-1.12 3.94-2.44 4.77-1.11.69-2.28.67-2.68.66-3.05-.1-5.2-2.86-6.67-4.81-2.45-3.25-4.76-6.3-3.66-9.53 1.23-3.59 5.71-4.64 6.41-4.79.51-.11 5.1-1.03 8.03 1.83Z"
        />
        <path
          className="clsw1-2"
          d="M1466.55 624.47c3.78-.43 6.37 2.63 9.84 6.74 1.61 1.91 2.34 3.36 2.15 4.9-.16 1.3-.92 2.19-1.19 2.49-2.01 2.3-5.51 2.22-7.95 2.12-4.07-.15-7.89-.3-9.7-3.2-2-3.22.02-7.36.35-8 .24-.47 2.43-4.6 6.49-5.06Z"
        />
        <path
          className="clsw1-2"
          d="M1462.5 649.09c.14-3.8 3.56-5.91 8.13-8.72 2.13-1.31 3.67-1.82 5.17-1.39 1.26.36 2.03 1.24 2.29 1.55 1.97 2.33 1.37 5.78.91 8.18-.76 4-1.47 7.76-4.61 9.11-3.48 1.5-7.27-1.12-7.85-1.54-.42-.3-4.18-3.09-4.03-7.18Z"
        />
        <path
          className="clsw1-2"
          d="M1484.08 657.53c-3.39-1.73-3.85-5.72-4.47-11.06-.29-2.48-.1-4.09.92-5.27.86-.99 1.98-1.31 2.37-1.42 2.95-.8 5.81 1.2 7.8 2.63 3.3 2.38 6.41 4.61 6.31 8.03-.11 3.79-4.09 6.12-4.71 6.47-.46.26-4.57 2.49-8.21.62Z"
        />
        <ellipse
          className="clsw1-1"
          cx={1481.43}
          cy={638.17}
          rx={7.14}
          ry={5.73}
          transform="rotate(-13.73 1481.964 638.337)"
        />
        <path
          className="clsw1-2"
          d="M1156.58 1274c-2.86 2.5-6.74 1.46-11.93.06-2.41-.65-3.84-1.42-4.56-2.81-.6-1.16-.49-2.32-.44-2.73.35-3.04 3.27-4.96 5.33-6.27 3.43-2.19 6.66-4.25 9.79-2.89 3.48 1.51 4.17 6.06 4.27 6.77.07.52.62 5.16-2.46 7.86Z"
        />
        <path
          className="clsw1-2"
          d="M1141.25 1250.63c2.72 2.66 1.99 6.6 1.01 11.88-.46 2.45-1.12 3.94-2.44 4.77-1.11.69-2.28.67-2.68.66-3.05-.1-5.2-2.86-6.67-4.81-2.45-3.25-4.76-6.3-3.66-9.53 1.23-3.59 5.71-4.64 6.41-4.79.51-.11 5.1-1.03 8.03 1.83Z"
        />
        <path
          className="clsw1-2"
          d="M1122.05 1257.35c3.78-.43 6.37 2.63 9.84 6.74 1.61 1.91 2.34 3.36 2.15 4.9-.16 1.3-.92 2.19-1.19 2.49-2.01 2.3-5.51 2.22-7.95 2.12-4.07-.15-7.89-.3-9.7-3.2-2-3.22.02-7.36.35-8 .24-.47 2.43-4.6 6.49-5.06Z"
        />
        <path
          className="clsw1-2"
          d="M1118.01 1281.97c.14-3.8 3.56-5.91 8.13-8.72 2.13-1.31 3.67-1.82 5.17-1.39 1.26.36 2.03 1.24 2.29 1.55 1.97 2.33 1.37 5.78.91 8.18-.76 4-1.47 7.76-4.61 9.11-3.48 1.5-7.27-1.12-7.85-1.54-.42-.3-4.18-3.09-4.03-7.18Z"
        />
        <path
          className="clsw1-2"
          d="M1139.59 1290.41c-3.39-1.73-3.85-5.72-4.47-11.06-.29-2.48-.1-4.09.92-5.27.86-.99 1.98-1.31 2.37-1.42 2.95-.8 5.81 1.2 7.8 2.63 3.3 2.38 6.41 4.61 6.31 8.03-.11 3.79-4.09 6.12-4.71 6.47-.46.26-4.57 2.49-8.21.62Z"
        />
        <ellipse
          className="clsw1-1"
          cx={1136.93}
          cy={1271.05}
          rx={7.14}
          ry={5.73}
          transform="rotate(-13.73 1137.402 1271.436)"
        />
        <path
          className="clsw1-2"
          d="M985.12 1569.86c-2.86 2.5-6.74 1.46-11.93.06-2.41-.65-3.84-1.42-4.56-2.81-.6-1.16-.49-2.32-.44-2.73.35-3.04 3.27-4.96 5.33-6.27 3.43-2.19 6.66-4.25 9.79-2.89 3.48 1.51 4.17 6.06 4.27 6.77.07.52.62 5.16-2.46 7.86Z"
        />
        <path
          className="clsw1-2"
          d="M969.79 1546.49c2.72 2.66 1.99 6.6 1.01 11.88-.46 2.45-1.12 3.94-2.44 4.77-1.11.69-2.28.67-2.68.66-3.05-.1-5.2-2.86-6.67-4.81-2.45-3.25-4.76-6.3-3.66-9.53 1.23-3.59 5.71-4.64 6.41-4.79.51-.11 5.1-1.03 8.03 1.83Z"
        />
        <path
          className="clsw1-2"
          d="M950.59 1553.21c3.78-.43 6.37 2.63 9.84 6.74 1.61 1.91 2.34 3.36 2.15 4.9-.16 1.3-.92 2.19-1.19 2.49-2.01 2.3-5.51 2.22-7.95 2.12-4.07-.15-7.89-.3-9.7-3.2-2-3.22.02-7.36.35-8 .24-.47 2.43-4.6 6.49-5.06Z"
        />
        <path
          className="clsw1-2"
          d="M946.55 1577.82c.14-3.8 3.56-5.91 8.13-8.72 2.13-1.31 3.67-1.82 5.17-1.39 1.26.36 2.03 1.24 2.29 1.55 1.97 2.33 1.37 5.78.91 8.18-.76 4-1.47 7.76-4.61 9.11-3.48 1.5-7.27-1.12-7.85-1.54-.42-.3-4.18-3.09-4.03-7.18Z"
        />
        <path
          className="clsw1-2"
          d="M968.13 1586.27c-3.39-1.73-3.85-5.72-4.47-11.06-.29-2.48-.1-4.09.92-5.27.86-.99 1.98-1.31 2.37-1.42 2.95-.8 5.81 1.2 7.8 2.63 3.3 2.38 6.41 4.61 6.31 8.03-.11 3.79-4.09 6.12-4.71 6.47-.46.26-4.57 2.49-8.21.62Z"
        />
        <ellipse
          className="clsw1-1"
          cx={965.47}
          cy={1566.9}
          rx={7.14}
          ry={5.73}
          transform="rotate(-13.73 965.891 1567.412)"
        />
        <path
          className="clsw1-2"
          d="M1129.37 1726.96c-4.31 3.77-10.13 2.2-17.94.1-3.63-.98-5.77-2.14-6.85-4.22-.91-1.75-.73-3.5-.66-4.1.52-4.57 4.91-7.45 8.01-9.43 5.16-3.29 10.01-6.39 14.73-4.35 5.24 2.27 6.27 9.12 6.42 10.18.1.78.93 7.77-3.7 11.82Z"
        />
        <path
          className="clsw1-2"
          d="M1106.32 1691.81c4.1 3.99 2.99 9.93 1.52 17.87-.69 3.69-1.68 5.92-3.66 7.17-1.67 1.04-3.43 1.01-4.04.99-4.59-.16-7.82-4.31-10.04-7.24-3.69-4.88-7.16-9.47-5.5-14.34 1.84-5.4 8.59-6.98 9.64-7.2.77-.17 7.67-1.55 12.08 2.75Z"
        />
        <path
          className="clsw1-2"
          d="M1077.44 1701.92c5.68-.65 9.58 3.96 14.8 10.13 2.43 2.87 3.53 5.05 3.23 7.37-.25 1.95-1.39 3.29-1.79 3.75-3.03 3.46-8.28 3.33-11.96 3.19-6.12-.23-11.87-.45-14.58-4.81-3.01-4.84.03-11.07.52-12.02.36-.7 3.65-6.92 9.77-7.61Z"
        />
        <path
          className="clsw1-2"
          d="M1071.35 1738.94c.21-5.72 5.35-8.88 12.23-13.12 3.2-1.97 5.52-2.73 7.77-2.09 1.9.54 3.05 1.86 3.44 2.33 2.97 3.51 2.06 8.69 1.37 12.3-1.14 6.01-2.22 11.67-6.94 13.7-5.24 2.26-10.94-1.69-11.81-2.31-.64-.46-6.29-4.65-6.07-10.8Z"
        />
        <path
          className="clsw1-2"
          d="M1103.81 1751.64c-5.09-2.61-5.79-8.6-6.73-16.63-.43-3.73-.14-6.16 1.39-7.93 1.29-1.49 2.98-1.97 3.56-2.13 4.44-1.2 8.74 1.81 11.73 3.96 4.97 3.58 9.64 6.94 9.48 12.07-.17 5.7-6.15 9.2-7.09 9.73-.68.38-6.87 3.74-12.35.94Z"
        />
        <ellipse
          className="clsw1-1"
          cx={1099.82}
          cy={1722.51}
          rx={10.74}
          ry={8.61}
          transform="rotate(-13.73 1100.263 1723.048)"
        />
        <path
          className="clsw1-2"
          d="M1258.86 1138.96c-4.31 3.77-10.13 2.2-17.94.1-3.63-.98-5.77-2.14-6.85-4.22-.91-1.75-.73-3.5-.66-4.1.52-4.57 4.91-7.45 8.01-9.43 5.16-3.29 10.01-6.39 14.73-4.35 5.24 2.27 6.27 9.12 6.42 10.18.1.78.93 7.77-3.7 11.82Z"
        />
        <path
          className="clsw1-2"
          d="M1235.81 1103.81c4.1 3.99 2.99 9.93 1.52 17.87-.69 3.69-1.68 5.92-3.66 7.17-1.67 1.04-3.43 1.01-4.04.99-4.59-.16-7.82-4.31-10.04-7.24-3.69-4.88-7.16-9.47-5.5-14.34 1.84-5.4 8.59-6.98 9.64-7.2.77-.17 7.67-1.55 12.08 2.75Z"
        />
        <path
          className="clsw1-2"
          d="M1206.93 1113.92c5.68-.65 9.58 3.96 14.8 10.13 2.43 2.87 3.53 5.05 3.23 7.37-.25 1.95-1.39 3.29-1.79 3.75-3.03 3.46-8.28 3.33-11.96 3.19-6.12-.23-11.87-.45-14.58-4.81-3.01-4.84.03-11.07.52-12.02.36-.7 3.65-6.92 9.77-7.61Z"
        />
        <path
          className="clsw1-2"
          d="M1200.84 1150.94c.21-5.72 5.35-8.88 12.23-13.12 3.2-1.97 5.52-2.73 7.77-2.09 1.9.54 3.05 1.86 3.44 2.33 2.97 3.51 2.06 8.69 1.37 12.3-1.14 6.01-2.22 11.67-6.94 13.7-5.24 2.26-10.94-1.69-11.81-2.31-.64-.46-6.29-4.65-6.07-10.8Z"
        />
        <path
          className="clsw1-2"
          d="M1233.3 1163.64c-5.09-2.61-5.79-8.6-6.73-16.63-.43-3.73-.14-6.16 1.39-7.93 1.29-1.49 2.98-1.97 3.56-2.13 4.44-1.2 8.74 1.81 11.73 3.96 4.97 3.58 9.64 6.94 9.48 12.07-.17 5.7-6.15 9.2-7.09 9.73-.68.38-6.87 3.74-12.35.94Z"
        />
        <ellipse
          className="clsw1-1"
          cx={1229.31}
          cy={1134.51}
          rx={10.74}
          ry={8.61}
          transform="rotate(-13.73 1229.811 1134.845)"
        />
        <path
          className="clsw1-2"
          d="M1561.54 1020.14c-4.31 3.77-10.13 2.2-17.94.1-3.63-.98-5.77-2.14-6.85-4.22-.91-1.75-.73-3.5-.66-4.1.52-4.57 4.91-7.45 8.01-9.43 5.16-3.29 10.01-6.39 14.73-4.35 5.24 2.27 6.27 9.12 6.42 10.18.1.78.93 7.77-3.7 11.82Z"
        />
        <path
          className="clsw1-2"
          d="M1538.5 984.99c4.1 3.99 2.99 9.93 1.52 17.87-.69 3.69-1.68 5.92-3.66 7.17-1.67 1.04-3.43 1.01-4.04.99-4.59-.16-7.82-4.31-10.04-7.24-3.69-4.88-7.16-9.47-5.5-14.34 1.84-5.4 8.59-6.98 9.64-7.2.77-.17 7.67-1.55 12.08 2.75Z"
        />
        <path
          className="clsw1-2"
          d="M1509.62 995.1c5.68-.65 9.58 3.96 14.8 10.13 2.43 2.87 3.53 5.05 3.23 7.37-.25 1.95-1.39 3.29-1.79 3.75-3.03 3.46-8.28 3.33-11.96 3.19-6.12-.23-11.87-.45-14.58-4.81-3.01-4.84.03-11.07.52-12.02.36-.7 3.65-6.92 9.77-7.61Z"
        />
        <path
          className="clsw1-2"
          d="M1503.53 1032.12c.21-5.72 5.35-8.88 12.23-13.12 3.2-1.97 5.52-2.73 7.77-2.09 1.9.54 3.05 1.86 3.44 2.33 2.97 3.51 2.06 8.69 1.37 12.3-1.14 6.01-2.22 11.67-6.94 13.7-5.24 2.26-10.94-1.69-11.81-2.31-.64-.46-6.29-4.65-6.07-10.8Z"
        />
        <path
          className="clsw1-2"
          d="M1535.99 1044.83c-5.09-2.61-5.79-8.6-6.73-16.63-.43-3.73-.14-6.16 1.39-7.93 1.29-1.49 2.98-1.97 3.56-2.13 4.44-1.2 8.74 1.81 11.73 3.96 4.97 3.58 9.64 6.94 9.48 12.07-.17 5.7-6.15 9.2-7.09 9.73-.68.38-6.87 3.74-12.35.94Z"
        />
        <ellipse
          className="clsw1-1"
          cx={1532}
          cy={1015.7}
          rx={10.74}
          ry={8.61}
          transform="rotate(-13.73 1532.559 1015.994)"
        />
        <path
          className="clsw1-2"
          d="M1630.49 603.94c-4.31 3.77-10.13 2.2-17.94.1-3.63-.98-5.77-2.14-6.85-4.22-.91-1.75-.73-3.5-.66-4.1.52-4.57 4.91-7.45 8.01-9.43 5.16-3.29 10.01-6.39 14.73-4.35 5.24 2.27 6.27 9.12 6.42 10.18.1.78.93 7.77-3.7 11.82Z"
        />
        <path
          className="clsw1-2"
          d="M1607.45 568.8c4.1 3.99 2.99 9.93 1.52 17.87-.69 3.69-1.68 5.92-3.66 7.17-1.67 1.04-3.43 1.01-4.04.99-4.59-.16-7.82-4.31-10.04-7.24-3.69-4.88-7.16-9.47-5.5-14.34 1.84-5.4 8.59-6.98 9.64-7.2.77-.17 7.67-1.55 12.08 2.75Z"
        />
        <path
          className="clsw1-2"
          d="M1578.56 578.9c5.68-.65 9.58 3.96 14.8 10.13 2.43 2.87 3.53 5.05 3.23 7.37-.25 1.95-1.39 3.29-1.79 3.75-3.03 3.46-8.28 3.33-11.96 3.19-6.12-.23-11.87-.45-14.58-4.81-3.01-4.84.03-11.07.52-12.02.36-.7 3.65-6.92 9.77-7.61Z"
        />
        <path
          className="clsw1-2"
          d="M1572.48 615.92c.21-5.72 5.35-8.88 12.23-13.12 3.2-1.97 5.52-2.73 7.77-2.09 1.9.54 3.05 1.86 3.44 2.33 2.97 3.51 2.06 8.69 1.37 12.3-1.14 6.01-2.22 11.67-6.94 13.7-5.24 2.26-10.94-1.69-11.81-2.31-.64-.46-6.29-4.65-6.07-10.8Z"
        />
        <path
          className="clsw1-2"
          d="M1604.94 628.63c-5.09-2.61-5.79-8.6-6.73-16.63-.43-3.73-.14-6.16 1.39-7.93 1.29-1.49 2.98-1.97 3.56-2.13 4.44-1.2 8.74 1.81 11.73 3.96 4.97 3.58 9.64 6.94 9.48 12.07-.17 5.7-6.15 9.2-7.09 9.73-.68.38-6.87 3.74-12.35.94Z"
        />
        <ellipse
          className="clsw1-1"
          cx={1600.95}
          cy={599.5}
          rx={10.74}
          ry={8.61}
          transform="rotate(-13.73 1601.518 599.643)"
        />
        <path
          className="clsw1-2"
          d="M1090.2 1881.53c-3.51 3.07-8.27 1.79-14.64.08-2.96-.8-4.71-1.75-5.59-3.45-.74-1.43-.6-2.85-.54-3.35.43-3.73 4.01-6.08 6.54-7.7 4.21-2.69 8.17-5.21 12.02-3.55 4.27 1.85 5.12 7.44 5.24 8.31.09.64.76 6.34-3.02 9.65Z"
        />
        <path
          className="clsw1-2"
          d="M1071.39 1852.84c3.34 3.26 2.44 8.1 1.24 14.59-.56 3.01-1.37 4.83-2.99 5.85-1.36.85-2.8.82-3.29.8-3.75-.13-6.38-3.52-8.19-5.91-3.01-3.99-5.84-7.73-4.49-11.7 1.5-4.41 7.01-5.69 7.87-5.88.63-.14 6.26-1.26 9.86 2.24Z"
        />
        <path
          className="clsw1-2"
          d="M1047.82 1861.09c4.64-.53 7.82 3.23 12.08 8.27 1.98 2.34 2.88 4.12 2.64 6.02-.2 1.59-1.13 2.69-1.46 3.06-2.47 2.82-6.76 2.72-9.76 2.61-4.99-.19-9.68-.36-11.9-3.92-2.46-3.95.03-9.03.42-9.81.29-.57 2.98-5.65 7.97-6.21Z"
        />
        <path
          className="clsw1-2"
          d="M1042.86 1891.31c.17-4.67 4.37-7.25 9.98-10.71 2.61-1.61 4.5-2.23 6.34-1.71 1.55.44 2.49 1.52 2.81 1.9 2.42 2.87 1.68 7.09 1.12 10.04-.93 4.91-1.81 9.52-5.66 11.18-4.28 1.84-8.93-1.38-9.64-1.89-.52-.37-5.14-3.79-4.95-8.81Z"
        />
        <path
          className="clsw1-2"
          d="M1069.34 1901.68c-4.16-2.13-4.73-7.02-5.49-13.57-.35-3.04-.12-5.02 1.13-6.47 1.05-1.22 2.43-1.61 2.91-1.74 3.62-.98 7.14 1.47 9.57 3.23 4.05 2.92 7.86 5.66 7.74 9.85-.14 4.65-5.02 7.51-5.78 7.94-.56.31-5.61 3.05-10.08.76Z"
        />
        <ellipse
          className="clsw1-1"
          cx={1066.09}
          cy={1877.9}
          rx={8.76}
          ry={7.03}
          transform="rotate(-13.73 1066.548 1878.503)"
        />
        <path
          className="clsw1-2"
          d="M1273.28 1692.86c-2.86 2.5-6.74 1.46-11.93.06-2.41-.65-3.84-1.42-4.56-2.81-.6-1.16-.49-2.32-.44-2.73.35-3.04 3.27-4.96 5.33-6.27 3.43-2.19 6.66-4.25 9.79-2.89 3.48 1.51 4.17 6.06 4.27 6.77.07.52.62 5.16-2.46 7.86Z"
        />
        <path
          className="clsw1-2"
          d="M1257.96 1669.49c2.72 2.66 1.99 6.6 1.01 11.88-.46 2.45-1.12 3.94-2.44 4.77-1.11.69-2.28.67-2.68.66-3.05-.1-5.2-2.86-6.67-4.81-2.45-3.25-4.76-6.3-3.66-9.53 1.23-3.59 5.71-4.64 6.41-4.79.51-.11 5.1-1.03 8.03 1.83Z"
        />
        <path
          className="clsw1-2"
          d="M1238.76 1676.21c3.78-.43 6.37 2.63 9.84 6.74 1.61 1.91 2.34 3.36 2.15 4.9-.16 1.3-.92 2.19-1.19 2.49-2.01 2.3-5.51 2.22-7.95 2.12-4.07-.15-7.89-.3-9.7-3.2-2-3.22.02-7.36.35-8 .24-.47 2.43-4.6 6.49-5.06Z"
        />
        <path
          className="clsw1-2"
          d="M1234.71 1700.82c.14-3.8 3.56-5.91 8.13-8.72 2.13-1.31 3.67-1.82 5.17-1.39 1.26.36 2.03 1.24 2.29 1.55 1.97 2.33 1.37 5.78.91 8.18-.76 4-1.47 7.76-4.61 9.11-3.48 1.5-7.27-1.12-7.85-1.54-.42-.3-4.18-3.09-4.03-7.18Z"
        />
        <path
          className="clsw1-2"
          d="M1256.29 1709.27c-3.39-1.73-3.85-5.72-4.47-11.06-.29-2.48-.1-4.09.92-5.27.86-.99 1.98-1.31 2.37-1.42 2.95-.8 5.81 1.2 7.8 2.63 3.3 2.38 6.41 4.61 6.31 8.03-.11 3.79-4.09 6.12-4.71 6.47-.46.26-4.57 2.49-8.21.62Z"
        />
        <ellipse
          className="clsw1-1"
          cx={1253.64}
          cy={1689.9}
          rx={7.14}
          ry={5.73}
          transform="rotate(-13.73 1254.14 1690.425)"
        />
        <path
          className="clsw1-2"
          d="M586.27 691.91c-7.48 6.54-17.59 3.82-31.15.17-6.29-1.69-10.02-3.72-11.9-7.33-1.58-3.03-1.27-6.07-1.15-7.12.9-7.93 8.53-12.94 13.91-16.38 8.96-5.72 17.38-11.09 25.57-7.55 9.09 3.93 10.89 15.84 11.14 17.68.18 1.35 1.62 13.49-6.42 20.52Z"
        />
        <path
          className="clsw1-2"
          d="M546.25 630.89c7.11 6.94 5.2 17.24 2.64 31.04-1.19 6.41-2.91 10.29-6.36 12.45-2.9 1.81-5.95 1.75-7.01 1.71-7.98-.27-13.58-7.48-17.43-12.57-6.41-8.48-12.43-16.45-9.55-24.89 3.2-9.37 14.92-12.11 16.74-12.51 1.33-.29 13.32-2.69 20.97 4.78Z"
        />
        <path
          className="clsw1-2"
          d="M496.1 648.44c9.87-1.12 16.64 6.88 25.71 17.59 4.21 4.98 6.12 8.76 5.61 12.8-.43 3.39-2.41 5.71-3.11 6.51-5.26 6-14.38 5.79-20.76 5.55-10.62-.4-20.6-.78-25.32-8.35-5.23-8.41.06-19.22.9-20.88.62-1.21 6.34-12.01 16.96-13.22Z"
        />
        <path
          className="clsw1-2"
          d="M485.54 712.72c.37-9.93 9.29-15.42 21.24-22.78 5.55-3.42 9.58-4.74 13.5-3.63 3.29.93 5.29 3.24 5.97 4.04 5.15 6.1 3.57 15.09 2.38 21.36-1.99 10.44-3.85 20.26-12.04 23.78-9.1 3.92-19-2.93-20.51-4.02-1.11-.8-10.93-8.07-10.53-18.75Z"
        />
        <path
          className="clsw1-2"
          d="M541.89 734.78c-8.84-4.53-10.05-14.94-11.68-28.88-.75-6.48-.25-10.69 2.41-13.77 2.23-2.59 5.17-3.43 6.19-3.7 7.7-2.09 15.18 3.14 20.36 6.87 8.62 6.21 16.73 12.05 16.47 20.96-.29 9.9-10.68 15.98-12.31 16.89-1.19.67-11.93 6.5-21.44 1.62Z"
        />
        <ellipse
          className="clsw1-1"
          cx={534.97}
          cy={684.2}
          rx={18.65}
          ry={14.95}
          transform="rotate(-13.73 535.179 684.41)"
        />
        <path
          className="clsw1-2"
          d="M654.87 1152.99c-5.31 4.64-12.49 2.71-22.11.12-4.47-1.2-7.12-2.64-8.45-5.2-1.12-2.15-.9-4.31-.82-5.06.64-5.63 6.06-9.19 9.88-11.63 6.36-4.06 12.34-7.87 18.15-5.36 6.45 2.79 7.73 11.24 7.91 12.55.13.96 1.15 9.58-4.56 14.57Z"
        />
        <path
          className="clsw1-2"
          d="M626.46 1109.67c5.05 4.92 3.69 12.24 1.87 22.04-.85 4.55-2.07 7.3-4.52 8.84-2.06 1.29-4.22 1.24-4.97 1.22-5.66-.19-9.64-5.31-12.37-8.93-4.55-6.02-8.83-11.68-6.78-17.67 2.27-6.65 10.6-8.6 11.89-8.88.95-.2 9.45-1.91 14.89 3.39Z"
        />
        <path
          className="clsw1-2"
          d="M590.85 1122.13c7.01-.8 11.81 4.88 18.25 12.49 2.99 3.53 4.35 6.22 3.99 9.09-.3 2.41-1.71 4.06-2.2 4.62-3.73 4.26-10.21 4.11-14.74 3.94-7.54-.28-14.63-.55-17.98-5.93-3.72-5.97.04-13.65.64-14.82.44-.86 4.5-8.53 12.04-9.39Z"
        />
        <path
          className="clsw1-2"
          d="M583.35 1167.77c.26-7.05 6.6-10.95 15.08-16.18 3.94-2.43 6.8-3.37 9.58-2.58 2.34.66 3.76 2.3 4.24 2.87 3.66 4.33 2.53 10.71 1.69 15.16-1.41 7.41-2.73 14.38-8.55 16.89-6.46 2.78-13.49-2.08-14.56-2.85-.79-.56-7.76-5.73-7.48-13.31Z"
        />
        <path
          className="clsw1-2"
          d="M623.36 1183.43c-6.28-3.21-7.14-10.6-8.29-20.5-.54-4.6-.18-7.59 1.71-9.78 1.59-1.84 3.67-2.43 4.39-2.63 5.47-1.49 10.78 2.23 14.46 4.88 6.12 4.41 11.88 8.55 11.69 14.88-.21 7.03-7.58 11.34-8.74 11.99-.84.47-8.47 4.61-15.22 1.15Z"
        />
        <ellipse
          className="clsw1-1"
          cx={618.45}
          cy={1147.51}
          rx={13.24}
          ry={10.62}
          transform="rotate(-13.73 618.71 1147.897)"
        />
        <path
          className="clsw1-2"
          d="M1391.64 390.81c-5.07 4.43-11.92 2.59-21.1.11-4.26-1.15-6.79-2.52-8.06-4.97-1.07-2.06-.86-4.11-.78-4.82.61-5.37 5.78-8.77 9.43-11.09 6.07-3.87 11.78-7.51 17.32-5.11 6.16 2.67 7.38 10.73 7.55 11.98.12.92 1.1 9.14-4.35 13.9Z"
        />
        <path
          className="clsw1-2"
          d="M1364.52 349.47c4.82 4.7 3.52 11.68 1.79 21.03-.81 4.34-1.97 6.97-4.31 8.43-1.96 1.23-4.03 1.18-4.75 1.16-5.4-.19-9.2-5.07-11.81-8.52-4.34-5.74-8.42-11.14-6.47-16.86 2.17-6.35 10.11-8.21 11.34-8.47.9-.19 9.02-1.82 14.21 3.24Z"
        />
        <path
          className="clsw1-2"
          d="M1330.55 361.36c6.69-.76 11.27 4.66 17.42 11.92 2.85 3.37 4.15 5.94 3.8 8.67-.29 2.3-1.63 3.87-2.1 4.41-3.56 4.07-9.74 3.92-14.06 3.76-7.19-.27-13.96-.53-17.15-5.66-3.55-5.7.04-13.02.61-14.15.42-.82 4.3-8.14 11.49-8.96Z"
        />
        <path
          className="clsw1-2"
          d="M1323.39 404.91c.25-6.73 6.29-10.45 14.39-15.44 3.76-2.32 6.49-3.21 9.14-2.46 2.23.63 3.58 2.19 4.05 2.74 3.49 4.13 2.42 10.22 1.61 14.47-1.35 7.07-2.61 13.72-8.16 16.11-6.16 2.65-12.87-1.99-13.89-2.72-.75-.54-7.4-5.47-7.13-12.7Z"
        />
        <path
          className="clsw1-2"
          d="M1361.58 419.86c-5.99-3.07-6.81-10.12-7.91-19.56-.51-4.39-.17-7.24 1.63-9.33 1.51-1.75 3.5-2.32 4.19-2.51 5.22-1.42 10.29 2.13 13.79 4.65 5.84 4.21 11.34 8.16 11.16 14.2-.2 6.71-7.24 10.83-8.34 11.44-.81.45-8.08 4.4-14.53 1.1Z"
        />
        <ellipse
          className="clsw1-1"
          cx={1356.88}
          cy={385.59}
          rx={12.63}
          ry={10.13}
          transform="rotate(-13.73 1357.379 385.668)"
        />
        <path
          className="clsw1-2"
          d="M759.49 237.76c-8.16 7.13-19.19 4.16-33.98.18-6.87-1.85-10.93-4.06-12.98-8-1.72-3.31-1.39-6.62-1.26-7.77.99-8.65 9.31-14.12 15.18-17.86 9.77-6.23 18.96-12.1 27.89-8.23 9.92 4.29 11.88 17.27 12.15 19.29.2 1.48 1.77 14.71-7.01 22.39Z"
        />
        <path
          className="clsw1-2"
          d="M715.83 171.19c7.76 7.57 5.67 18.8 2.88 33.86-1.3 6.99-3.18 11.22-6.94 13.58-3.16 1.98-6.49 1.91-7.64 1.87-8.7-.3-14.81-8.16-19.01-13.71-6.99-9.25-13.56-17.94-10.42-27.15 3.49-10.22 16.28-13.22 18.26-13.64 1.45-.31 14.53-2.93 22.87 5.21Z"
        />
        <path
          className="clsw1-2"
          d="M661.13 190.34c10.77-1.22 18.15 7.5 28.04 19.19 4.59 5.43 6.68 9.56 6.12 13.96-.47 3.7-2.63 6.23-3.39 7.1-5.73 6.55-15.69 6.31-22.65 6.05-11.58-.44-22.48-.85-27.62-9.11-5.71-9.17.06-20.97.98-22.78.68-1.33 6.92-13.1 18.5-14.42Z"
        />
        <path
          className="clsw1-2"
          d="M649.61 260.46c.4-10.83 10.13-16.82 23.17-24.85 6.05-3.73 10.45-5.17 14.72-3.97 3.59 1.02 5.77 3.53 6.51 4.41 5.62 6.65 3.89 16.46 2.59 23.3-2.17 11.39-4.2 22.1-13.14 25.94-9.92 4.27-20.72-3.2-22.37-4.38-1.21-.87-11.92-8.8-11.49-20.45Z"
        />
        <path
          className="clsw1-2"
          d="M711.09 284.52c-9.64-4.94-10.97-16.29-12.74-31.5-.82-7.06-.27-11.66 2.63-15.02 2.44-2.82 5.64-3.74 6.75-4.04 8.4-2.28 16.56 3.42 22.21 7.49 9.41 6.77 18.25 13.14 17.97 22.87-.32 10.8-11.65 17.43-13.42 18.43-1.3.73-13.01 7.09-23.39 1.77Z"
        />
        <ellipse
          className="clsw1-1"
          cx={703.53}
          cy={229.34}
          rx={20.34}
          ry={16.31}
          transform="rotate(-13.73 703.799 229.416)"
        />
        <path
          className="clsw1-2"
          d="M467.98 542.13c-3.32 2.9-7.81 1.69-13.82.07-2.79-.75-4.45-1.65-5.28-3.25-.7-1.35-.56-2.69-.51-3.16.4-3.52 3.79-5.74 6.17-7.27 3.98-2.54 7.71-4.92 11.35-3.35 4.03 1.75 4.83 7.03 4.94 7.85.08.6.72 5.98-2.85 9.11Z"
        />
        <path
          className="clsw1-2"
          d="M450.22 515.06c3.16 3.08 2.31 7.65 1.17 13.77-.53 2.84-1.29 4.56-2.82 5.52-1.29.81-2.64.78-3.11.76-3.54-.12-6.03-3.32-7.73-5.58-2.84-3.76-5.52-7.3-4.24-11.04 1.42-4.16 6.62-5.38 7.43-5.55.59-.13 5.91-1.19 9.3 2.12Z"
        />
        <path
          className="clsw1-2"
          d="M427.97 522.84c4.38-.5 7.38 3.05 11.41 7.8 1.87 2.21 2.72 3.89 2.49 5.68-.19 1.51-1.07 2.54-1.38 2.89-2.33 2.66-6.38 2.57-9.21 2.46-4.71-.18-9.14-.34-11.23-3.7-2.32-3.73.02-8.53.4-9.26.28-.54 2.81-5.33 7.53-5.87Z"
        />
        <path
          className="clsw1-2"
          d="M423.29 551.37c.16-4.4 4.12-6.84 9.42-10.11 2.46-1.52 4.25-2.1 5.99-1.61 1.46.41 2.35 1.44 2.65 1.79 2.28 2.71 1.58 6.69 1.05 9.48-.88 4.63-1.71 8.99-5.34 10.55-4.04 1.74-8.43-1.3-9.1-1.78-.49-.35-4.85-3.58-4.67-8.32Z"
        />
        <path
          className="clsw1-2"
          d="M448.29 561.15c-3.92-2.01-4.46-6.63-5.18-12.81-.33-2.87-.11-4.74 1.07-6.11.99-1.15 2.29-1.52 2.75-1.64 3.42-.93 6.74 1.39 9.03 3.05 3.83 2.76 7.42 5.35 7.31 9.3-.13 4.39-4.74 7.09-5.46 7.49-.53.3-5.29 2.88-9.51.72Z"
        />
        <ellipse
          className="clsw1-1"
          cx={445.22}
          cy={538.71}
          rx={8.27}
          ry={6.63}
          transform="rotate(-13.73 445.39 538.861)"
        />
        <path
          className="clsw1-2"
          d="M1047.82 179.17c-5.25 4.59-12.35 2.68-21.87.12-4.42-1.19-7.04-2.61-8.36-5.15-1.11-2.13-.89-4.26-.81-5 .64-5.57 5.99-9.09 9.77-11.5 6.29-4.01 12.2-7.79 17.95-5.3 6.38 2.76 7.65 11.12 7.82 12.41.13.95 1.14 9.47-4.51 14.41Z"
        />
        <path
          className="clsw1-2"
          d="M1019.72 136.33c4.99 4.87 3.65 12.1 1.85 21.79-.84 4.5-2.05 7.22-4.47 8.74-2.03 1.27-4.18 1.23-4.92 1.2-5.6-.19-9.53-5.25-12.24-8.83-4.5-5.95-8.73-11.55-6.7-17.48 2.25-6.58 10.48-8.51 11.75-8.78.94-.2 9.35-1.89 14.72 3.35Z"
        />
        <path
          className="clsw1-2"
          d="M984.52 148.65c6.93-.79 11.68 4.83 18.05 12.35 2.96 3.49 4.3 6.15 3.94 8.99-.3 2.38-1.69 4.01-2.18 4.57-3.69 4.22-10.1 4.06-14.57 3.89-7.46-.28-14.47-.54-17.78-5.86-3.68-5.9.04-13.49.63-14.66.44-.85 4.45-8.43 11.91-9.28Z"
        />
        <path
          className="clsw1-2"
          d="M977.1 193.78c.26-6.97 6.52-10.83 14.91-15.99 3.9-2.4 6.73-3.33 9.48-2.55 2.31.65 3.71 2.27 4.19 2.84 3.62 4.28 2.51 10.59 1.67 14.99-1.39 7.33-2.7 14.22-8.46 16.7-6.39 2.75-13.34-2.06-14.4-2.82-.78-.56-7.67-5.66-7.39-13.16Z"
        />
        <path
          className="clsw1-2"
          d="M1016.67 209.26c-6.21-3.18-7.06-10.49-8.2-20.27-.53-4.55-.18-7.5 1.69-9.67 1.57-1.82 3.63-2.41 4.35-2.6 5.41-1.47 10.66 2.2 14.29 4.82 6.05 4.36 11.75 8.46 11.56 14.72-.21 6.95-7.5 11.22-8.64 11.86-.83.47-8.38 4.56-15.05 1.14Z"
        />
        <ellipse
          className="clsw1-1"
          cx={1011.8}
          cy={173.75}
          rx={13.09}
          ry={10.5}
          transform="rotate(-13.73 1012.167 173.766)"
        />
        <path
          className="clsw1-3"
          d="M1563.53 906.49c1.15-4.19 4.34-13.47 13.08-20.75 10.35-8.62 22.09-9.09 28.21-9.25 26.18-.67 55.8 16.89 54.22 29.11-1.58 12.13-34.2 20.97-60.82 16.26-15.79-2.79-27.55-10.01-34.69-15.37Z"
        />
        <path
          className="clsw1-2"
          d="M1563.65 906.61c3.92-.47 12.71-2.06 20.44-8.75 9.16-7.92 11.17-18.08 12.14-23.4 4.15-22.73-7.64-50.78-18.84-50.96-11.13-.18-23.5 27.12-22.87 50.92.38 14.11 5.28 25.29 9.13 32.19Z"
        />
        <circle className="clsw1-3" cx={1611.66} cy={845.4} r={3.07} />
        <circle className="clsw1-3" cx={1608.89} cy={865.38} r={5.96} />
        <circle className="clsw1-2" cx={1634.05} cy={864.48} r={4.73} />
        <path
          className="clsw1-3"
          d="M774.52 1675.28c.47-4.65 1.02-15.17-3.32-25.51-5.15-12.25-13.98-16.68-18.62-18.89-19.83-9.48-48.19-1.58-50.92 11.38-2.71 12.87 19.42 32.84 41.33 36.99 12.99 2.47 24.34-.92 31.53-3.97Z"
        />
        <path
          className="clsw1-2"
          d="M774.38 1675.37c-2.85-1.8-9.07-6.37-12.83-15.77-4.46-11.14-2.72-22.15-1.75-27.89 4.16-24.52 22.24-49.1 30.89-45.51 8.58 3.56 9.25 35.49 1.08 59.5-4.84 14.23-12.21 23.95-17.39 29.68Z"
        />
        <ellipse
          className="clsw1-3"
          cx={757.38}
          cy={1596.95}
          rx={3.31}
          ry={2.53}
          transform="rotate(-81.38 757.483 1596.99)"
        />
        <ellipse
          className="clsw1-3"
          cx={753.04}
          cy={1618.21}
          rx={6.42}
          ry={4.92}
          transform="rotate(-81.38 753.147 1618.255)"
        />
        <ellipse
          className="clsw1-2"
          cx={734.06}
          cy={1608.83}
          rx={5.1}
          ry={3.9}
          transform="rotate(-81.38 734.168 1608.874)"
        />
        <path
          className="clsw1-3"
          d="M491.04 459.13c.72-4.31 1.7-14.16-3.59-24.85-6.27-12.66-17.45-18.65-23.33-21.7-25.13-13.02-61.6-11.31-65.42.42-3.8 11.65 24 35.07 51.92 43.48 16.55 4.98 31.15 4.08 40.43 2.66Z"
        />
        <path
          className="clsw1-2"
          d="M490.87 459.18c-3.61-2.28-11.44-7.89-16.01-17.56-5.42-11.46-2.91-21.55-1.51-26.79 5.95-22.39 29.72-42 40.68-36.84 10.89 5.12 10.91 35.52-.16 56.6-6.56 12.5-16.23 20.21-23 24.59Z"
        />
        <ellipse
          className="clsw1-3"
          cx={471.14}
          cy={381.4}
          rx={3.07}
          ry={3.32}
          transform="rotate(-63.95 471.123 381.403)"
        />
        <ellipse
          className="clsw1-3"
          cx={465.05}
          cy={400.67}
          rx={5.96}
          ry={6.44}
          transform="rotate(-63.95 465.032 400.664)"
        />
        <ellipse
          className="clsw1-2"
          cx={441.01}
          cy={387.91}
          rx={4.73}
          ry={5.12}
          transform="rotate(-63.95 441.003 387.912)"
        />
        <path
          className="clsw1-1"
          d="M765.73 1248.36c-2.12-5.63-6.24-18.67-3.75-34.18 2.96-18.38 13.36-28.88 18.87-34.26 23.51-22.99 64.02-28.65 71.84-13.73 7.77 14.83-15.46 52.38-43.46 69.77-16.6 10.31-32.88 12.29-43.5 12.4Z"
        />
        <path
          className="clsw1-2"
          d="M765.93 1248.39c3.25-3.86 10.1-13.1 12.12-27.1 2.39-16.59-3.48-29.6-6.62-36.33-13.45-28.79-45.56-49.96-55.98-40.63-10.35 9.26-.98 50.12 17.67 76.04 11.06 15.37 24.04 23.62 32.82 28.03Z"
        />
        <ellipse
          className="clsw1-1"
          cx={763.51}
          cy={1139.54}
          rx={3.65}
          ry={4.3}
          transform="rotate(-6.67 763.39 1139.355)"
        />
        <ellipse
          className="clsw1-1"
          cx={776.15}
          cy={1164.11}
          rx={7.08}
          ry={8.36}
          transform="rotate(-6.67 775.992 1163.938)"
        />
        <ellipse
          className="clsw1-2"
          cx={798.55}
          cy={1141.71}
          rx={5.62}
          ry={6.64}
          transform="rotate(-6.67 798.389 1141.567)"
        />
        <path
          className="clsw1-1"
          d="M1242.32 1618.77c3.39-1.86 10.9-6.48 16.81-14.98 7-10.07 7.41-19.34 7.56-24.16.62-20.61-13.49-39.73-23.36-35.69-9.81 4.01-17.05 31.53-13.32 51.25 2.21 11.69 8.01 19.23 12.32 23.58Z"
        />
        <path
          className="clsw1-2"
          d="M1242.22 1618.71c.39-3.17 1.7-10.4 7.13-17.98 6.43-8.97 14.65-12.88 18.95-14.85 18.38-8.45 41.02-5.68 41.13 3.04.11 8.66-21.99 24.58-41.22 29.55-11.4 2.94-20.42 1.67-25.99.25Z"
        />
        <ellipse
          className="clsw1-1"
          cx={1291.83}
          cy={1567.16}
          rx={2.82}
          ry={2.11}
          transform="rotate(-45.76 1291.93 1567.208)"
        />
        <ellipse
          className="clsw1-1"
          cx={1275.67}
          cy={1573.9}
          rx={5.48}
          ry={4.09}
          transform="rotate(-45.76 1275.778 1573.96)"
        />
        <ellipse
          className="clsw1-2"
          cx={1276.48}
          cy={1554.03}
          rx={4.35}
          ry={3.25}
          transform="rotate(-45.76 1276.585 1554.088)"
        />
        <path
          className="clsw1-1"
          d="M1474.63 394.78c2.77-3.34 8.69-11.18 11.3-21.63 3.09-12.39-.38-20.78-2.26-25.1-8.04-18.49-30.86-28.29-39.51-19.78-8.59 8.46-4.58 36.36 7.63 51.89 7.24 9.21 16.5 12.95 22.84 14.63Z"
        />
        <path
          className="clsw1-2"
          d="M1474.5 394.77c-.93-3-2.6-10.03-.1-19.43 2.95-11.14 9.92-18.7 13.6-22.6 15.7-16.66 40.59-25.56 44.37-17.92 3.76 7.58-12.68 32.7-30.74 46.71-10.71 8.31-20.69 11.71-27.13 13.24Z"
        />
        <ellipse
          className="clsw1-1"
          cx={1504.77}
          cy={324.44}
          rx={3.08}
          ry={2.19}
          transform="rotate(-55.5 1504.823 324.419)"
        />
        <ellipse
          className="clsw1-1"
          cx={1490.68}
          cy={338.48}
          rx={5.97}
          ry={4.26}
          transform="rotate(-55.5 1490.737 338.46)"
        />
        <ellipse
          className="clsw1-2"
          cx={1483.16}
          cy={320.55}
          rx={4.74}
          ry={3.38}
          transform="rotate(-55.5 1483.206 320.532)"
        />
        {children}
      </g>
    </svg>
  );
}
